/* eslint-disable react/jsx-props-no-spreading */
import { ReactNode } from 'react';
import PickerOption from '../../components/PickerOption/PickerOption';
import { IPickerOption, IPickerProps } from '../../types';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { DEBOUNCE_TIME } from 'src/constants/main';
import { IPagination } from 'src/types/main';
import SearchInput from 'src/view/components/Controls/SearchInput/SearchInput';
import ScrollableList from 'src/view/components/ScrollableList/ScrollableList';
import '../../components/PickerOption/style.scss';
import '../../style.scss';

type TLazyList<T> = Pick<IPickerProps<T>, 'searchable' | 'emptyText' | 'optionClassName' | 'viewedSize'>;

interface IProps<T> extends TLazyList<T> {
  searchValue?: string;
  loading?: boolean;
  showSearch?: boolean;
  pages: number[];
  pagination: IPagination<T>;
  onFetch: (...args: any[]) => void;
  renderItem: (item: T | IPickerOption | undefined, index: number) => ReactNode;
  onSearch: (search: string) => void;
}

const PickerLazyListContent = <T,>(props: IProps<T>): JSX.Element | null => {
  return (
    <>
      {props.showSearch ? (
        <PickerOption optionClassName="picker-option__search" {...props}>
          <SearchInput
            withResetIcon
            customPlaceholder
            onChangeText={props.onSearch}
            value={props.searchValue}
            placeholder="txt_search"
            loading={props.loading}
            debounceDelay={DEBOUNCE_TIME.LARGE}
            customPlaceholderIcon={Icons.Search}
            inputClassName="custom-picker__search-input family-semibold text-size-16 color-dark"
            customPlaceholderClassName="family-medium text-size-16 color-gray2"
          />
        </PickerOption>
      ) : null}
      <ScrollableList<T | undefined>
        autoFetch
        scrollToTop={false}
        emptyListInFooter={false}
        fetch={props.onFetch}
        list={props.pagination.data}
        loading={props.loading}
        refreshing={props.loading}
        current_page={props.pagination.current_page}
        last_page={props.pagination.last_page}
        renderItem={(item, index) => props.renderItem(item, index)}
        pages={props.pages}
        emptyListText={props.emptyText || 'items_not_found'}
        emptyListTextClassName="family-semibold text-size-16 color-dark"
        scrollbarSize="small"
        scrollbar
      />
    </>
  );
};

export default PickerLazyListContent;
